import { render } from "./clerkStatisticsTotal.vue?vue&type=template&id=cd5629f6"
import script from "./clerkStatisticsTotal.vue?vue&type=script&lang=js"
export * from "./clerkStatisticsTotal.vue?vue&type=script&lang=js"

import "./clerkStatisticsTotal.vue?vue&type=style&index=0&id=cd5629f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__